const questsData = {
  id: "quests-guide",
  title: "Quests",
  category: "Component",
  override: "wiki/quests",
  sections: [
    // {
    //   id: ,
    //   name: "",
    //   status: "available/expired",
    //   npc: "",
    //   location: "",
    //   prerequisites: "",
    //   description: ``,
    //   items: ["None"],
    //   reward: "",
    //   otherinfo: "",
    //   image: [],
    // },
    {
      id: 82,
      name: "Offspring Incubation",
      status: "available",
      npc: "Cooper",
      prerequisites: "Animal Care Level 15",
      location: "Terra Villa",
      description: `<i class="fa-solid fa-1" style="color: #9a7997;"></i> Speak to Cooper by the Animal Park on the right side of Terra Villa to start this quest once you've reached level 15 Animal Care.<br/>      
       <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_024820746.png" alt="Cooper" height="300"/><br/>
       <i class="fa-solid fa-2" style="color: #9a7997;"></i> Cooper explains the details about animal offspring and how each animal drops an offspring! He says you can get one now but you'll need an Incubator.
       <br/> <i class="fa-solid fa-3" style="color: #9a7997;"></i>  Go to the Pet Store and buy an Incubator from the shop.     
       <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_025129373.png" alt="Pet Store Items" height="300"/><br/>
       <i class="fa-solid fa-4" style="color: #9a7997;"></i> Take the Incubator back to Cooper to progress the quest. Once you're done presenting the Incubator to Cooper, take it to your Speck or land and place it.
       <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Now you'll need an Offspring from any animal. Chickens are the lowest level Offspring you can get (At Level 15)
       <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> Place the Offspring inside the Incubator. Cooper will give you the thumbs up once you've placed an Offspring in the Incubator. He explains you need Incuvite Potions to hatch them.
       <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_025729234.png" alt="Incubator" height="300"/><br/>
       <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> To hatch the pet, you need 5 Incuvite Potions and time. To get Incuvite Potions, you'll need to find a Potion Table. There's one inside the Pet Store. You can use that one.
       <br/><i class="fa-solid fa-8" style="color: #9a7997;"></i> You'll need 1 Salt to start the table, and multiple ingredients to get you going. Once you have 5 Potions, take it back to your Incubator.
       <br/><i class="fa-solid fa-9" style="color: #9a7997;"></i> Now, you can place 1 Incuvite Potion every 18 Hours. Once you've placed all 5, you'll be able to hatch your Animal!
       <br/><br/>Hatching the Animal completes the quest.
      `,
      items: ["Incubator, Offspring (Any), 5 Incuvite Potions"],
      reward: "10 Reputation",
      otherinfo: "Live Jan 22 2026 - Ongoing",
      image: [],
    },
    {
      id: 81,
      name: "A Wild Approach",
      status: "available",
      npc: "Cooper",
      prerequisites: "Less than Animal Care Level 5",
      location: "Terra Villa",
      description: `<i class="fa-solid fa-1" style="color: #9a7997;"></i> Speak to Cooper by the Animal Park on the right side of Terra Villa to start this quest. You must be less than Animal Care Level 5.<br/>      
       <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_024820746.png" alt="Cooper" height="300"/><br/>
       <i class="fa-solid fa-2" style="color: #9a7997;"></i> Cooper teaches you how to feed the Chickens! He'll give you a Mini Farmamix Recipe that you can use at the Recycler. 
       <br/> <i class="fa-solid fa-3" style="color: #9a7997;"></i> Use the recipe card on yourself, then walk down a bit to the Recycler.   
       <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_030419022.png" alt="Recycler" height="300"/><br/>
       <i class="fa-solid fa-4" style="color: #9a7997;"></i> Open up the Recycler and Craft the Mini Farmamix. It requires 5 Popberry Jam.
       <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Once you've crafted the Mini Farmamix, go back to Cooper. He'll give you a Gathering Satchel that you can use to collect from animals.
       <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> Feed the Chicken next to Cooper with the Farmamix you crafted. Each time the item is ready, use the Gathering Satchel to collect the items. 
       <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> When you've gotten 2 Eggs and 3 Animal Turd, return to Cooper to complete the quest.
      `,
      items: ["5 Popberry Jam, 3 Animal Turd, 2 Eggs"],
      reward: "100 Coins, 5 Reputation",
      otherinfo: "Live Jan 22 2026 - Ongoing",
      image: [],
    },
    {
      id: 80,
      name: "The Barney Who Lost Christmas",
      status: "expired",
      npc: "Margaret",
      location: "Terra Villa",
      description: `Talk to Margaret to get the Empty Cookie Plate and start your hunt for Content Creator Cookies!<br/>
       <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_024236711.png" alt="Margaret Quuest 80" height="300"/><br/>
       🍪 3 Cookies are added each day to Terra Villa and different lands for a total of 45 Cookies!
       <br/>🍪 Find them all, place them on the plate. When you've found all the cookies, remove your completed plate and take it to Margaret for a sweet surprise.`,
      items: ["None"],
      reward: "Margaret's Whirlygig, 1 Berry Blast, 10 Reputation",
      otherinfo: "Live Jan 6 2026 - Jan 22 2026",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_023915442.png"],
    },
    {
      id: 79,
      name: "The Barney Who Lost Christmas",
      status: "expired",
      npc: "Barney",
      location: "Terra Villa",
      description: `Talk to Barney in Terra Villa to start the quest and find all the ornaments around Terra Villa to complete the quest.<br/>
      Barney gives you a different tree depending on which Union you're in! Change your Union if you want a different tree.`,
      items: ["None"],
      reward: "Finished Pixmas Tree for 2025, and 10 Reputation",
      otherinfo: "Live Dec 18 2025 - Dec 26 2025",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2026-01-22_023731616.png"],
    },
    {
      id: 78,
      name: "Wart's Great Escape",
      status: "expired",
      npc: "Hantao",
      location: "Terra Villa",
      description: `Help Hantao find Wart the Snail 3x per day for 3 days and take them to his cage (in the cave under the Drunken Goose) for a Moki Ball!<br/>
      Each Moki Ball has the potential for a different type of prize:
      <br/>🎁 Moku Booster Boxes
      <br/>🎁 Moku Champion Slots
      <br/>🎁 Moku NFTs
      <br/>🎁 Moku UGC
      <br/>🎁 And more!`,
      items: ["Wart"],
      reward: "Moki Ball, 5 Reputation",
      otherinfo: "Live Dec 2 2025 - Dec 4 2025",
      image: [],
    },{
      id: 77,
      name: "Gabby's YGG Gourd Gig 2025",
      status: "expired",
      npc: "Gabby",
      location: "YGG Arena",
      description: `Grow YGG Gourds for 4 days in a row to complete the YGG Quest!<br/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Head to the bus stop that is left of the fountain and click on it! You will be instantly transported to the YGG Play Summit Arena<br/>
        <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B5D259BAC-2404-4FF3-9396-00F3505ACCE0%7D.png" alt="Bus Stop" height="300"/><br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You should get the quest upon entering the building. Grow 50 YGGourds per day<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Walk around to each of the booths to collect seeds from different vendors. You collect every 24 hours from the last time you collected. <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> When you have all 50 seeds, plant them in the YGG logo in the center and wait 5 minutes <br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i> Harvest the YGGourds and return to Gabby with the YGGourds. He will give you 1 or 2 PixTix depending on the day<br/>
        <i class="fa-solid fa-6" style="color: #9a7997;"></i> When all 4 days have completed, the quest will be marked as "Completed"<br/>`,
      items: ["325 Energy to plant, water and harvest the seeds each day"],
      reward: "5 PixTix",
      otherinfo: "Live Nov 19 2025 - Nov 25 2025",
      image: [
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BF13E7271-B6B7-41B9-A5DC-1284C8CA32A9%7D.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BEA929F3B-9965-4BA9-A32A-4865E5063D28%7D.png",
      ],
    },
    {
      id: 76,
      name: "Ember Unleashed",
      status: "available",
      npc: "Glint, Phoenix",
      location: "Outside the Guild Hall, and the Mountains",
      prerequisites: "None",
      description: `This is a new Fableborne Themed Quest added to the game! Talk to Glint to the left of the Guild Hall to get started.
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-11-19_154215694.png"  alt="Glint's Location" class="w-60"/>
      Once you've started the quest with Glint, click on the raft. It'll take you to the new map!
      <br/>Walk through the map up to the top, and keep going once you're at the mountains. Go all the way to the top, and you'll meet the Phoenix.
      <br/>Make sure you have at least one space in your bag. The Phoenix will give you a recipe for a Fire Blessing.
      <br/>Eat the Fire Blessing and then go craft it at a Stoneshaping Kit.
      <br/>The Fire Blessing requires 1 Berry Blast, 25 Popberries, 18 Ochrux Matrix, 10 Eggs and 5 Sap.
      <br/>You get a new Fire Blessing every 20 hours for 3 days. 
      <br/>Once you have the Fire Blessing, take it back to the Phoenix and it will give you a reward in return. 
      <br/>Do this for 3 days in a row to get all the prizes and complete the quest.`,
      items: ["3 Berry Blast", '75 Popberries','54 Ochrux Matrix', "30 Eggs", "15 Sap"],
      reward: "25 Reputation, 1 Phoenix Egg, 1 Fableborne Wardrobe Skin, 1 Ember Avatar Outfit",
      otherinfo: "Nov 11th - Ongoing",
      image: [],
    },
    {
      id: 75,
      name: "Memory of Fire: Hands of the Hearth",
      status: "available",
      npc: "Mitchell",
      location: "Hearth Hall",
      prerequisites: "Being a Land Owner & Memory of Fire: Echoes of the First Flame",
      description: `Chat with Mitchell after picking your Union. He'll explain to you about the Yieldstone Press. Bring a Yieldstone Press to him (buy from Hearth Halls Chamber) and he'll give you a reward.
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/image_2025-11-03_012941369.png" alt="Mitchell" class="w-60"/>`,
      items: ["None"],
      reward: "10 Reputation, 10 Yield Reactors",
      otherinfo: "Oct 30th - Ongoing",
      image: [],
    },{
      id: 74,
      name: "Memory of Fire: The Hearth's Hunger",
      status: "available",
      npc: "Lucia",
      location: "Hearth Hall",
      prerequisites: "Memory of Fire: Pressing Matters",
      description: `Chat with Lucia after you've completed the last quest with Albus. Lucia will teach you about Offerings. She'll give you 1 Power Offering to use on your Hearth.
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/image_2025-11-03_012517567.png" alt="Lucia" class="w-60"/>
      <br/>Go ahead and deposit the offering in your Hearth. She gives you a quick lesson on how to use Offerings, then gives you a defense offering as well.`,
      items: ["None"],
      reward: "1 Power Offering, 1 Defense Offering, 5 Reputation",
      otherinfo: "Oct 30th - Ongoing",
      image: [],
    },
    {
      id: 73,
      name: "Memory of Fire: Pressing Matters",
      status: "available",
      npc: "Albus",
      location: "Hearth Hall",
      prerequisites: "Memory of Fire: Embers of Rivalry",
      description: `If you already got a Yieldstone from a Yieldstone Press, this might not seem like a big deal to you. But if you got it from the Taskboard, this is another way to acquire Yieldstones.
      <br/><br/>Albus will give you 1 Yield Reactor. Find a Yieldstone Press to use the Reactor on. You'll immediately get a Yieldstone for the Union of the land you've used it on.
      <br/>If you use the Reactor on a land assigned to Wildgroves, you'll get a random tier yieldstone for the Wildgrove Union (Verdant). Same for Reaper and Seedwrights.
      <br/>You can see the Union the land is assigned to on the Gate of the land. Just click the gate, and the Union will be written there.
      <br/>
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/image_2025-11-03_011959658.png" alt="Land Union" class="w-60"/>
      <br/>After you've used the Yieldstone Press, you'll complete the quest. To make more Yield Reactors, buy recipes from the Hearth Halls Chamber, and craft them. 
      `,
      items: ["None"],
      reward: "1 Yield Reactor, 5 Reputation",
      otherinfo: "Oct 30th - Ongoing",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/image_2025-11-03_012204667.png"],
    },
    {
      id: 72,
      name: "Memory of Fire: Embers of Rivalry",
      status: "available",
      npc: "Albus",
      location: "Hearth Hall",
      prerequisites: "Memory of Fire: The Land Remembers",
      description: `Now that you know how to deposit, Albus will teach you about sabotage.
      <br/>You'll get this quest when you enter the Hearth Hall once again. Get a yieldstone for another Union (Not your own), and deposit it into another Union's Hearth.
      <br/>To get the yieldstone, fill out tasks on your taskboard until you can fulfill one that gives you a yieldstone from another Union.
      <br/><br/>Here's a quick tip of all the Yieldstones and which Union they belong to. Get one that matches any that's not your own, and deposit them back in:
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/image_2025-11-03_010942261.png" alt="Yieldstone Chart" class="w-120"/>
      <br/>After you've deposited an enemy yieldstone (this deposit will be a sabotage), you will complete the quest! Your first sabotage.
      `,
      items: ["None"],
      reward: "1500 Coins, 5 Reputation",
      otherinfo: "Oct 30th - Ongoing",
      image: [],
    },
    {
      id: 71,
      name: "Memory of Fire: The Land Remembers",
      status: "available",
      npc: "Albus",
      location: "Hearth Hall",
      prerequisites: "Memory of Fire: Echoes of the First Flame",
      description: `After you've chosen your Union, Albus will give you a Tier 1 Yieldstone. Deposit it into the Hearth of your Union you've chosen. 
      <br/>If you chose Wildgroves, deposit your yieldstone into the Wildgroves Hearth.
      <br/>
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/Wildgrove.png" alt="Wildgroves" class="inline h-20 w-20"/> 
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/HearthFire_WildGrove_Blue.gif" alt="Wildgroves Hearth" class="inline h-60 w-60"/>
      <br/>If you chose Seedwrights, deposit your yieldstone into the Seedwrights Hearth.
      <br/>
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/Seedwrights.png" alt="Seedwrights" class="inline h-20 w-20"/> 
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/HearthFire_SeedWrights_Blue.gif" alt="Seedwrights Hearth" class="inline h-60 w-60"/>
      <br/>If you chose Reapers, deposit your yieldstone into the Reapers Hearth.
      <br/>
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/Reapers.png" alt="Reapers" class="inline h-20 w-20"/> 
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/HearthFire_Reapers_Blue.gif" alt="Reapers Hearth" class="inline h-60 w-60"/>
      <br/>
      <br/>Once you've deposited the Yieldstone, you'll complete the quest. This is your first lesson on depositing into Hearths.`,
      items: ["None"],
      reward: "1000 Coins, 5 Reputation",
      otherinfo: "Oct 30th - Ongoing",
      image: [],
    },{
      id: 70,
      name: "Memory of Fire: Echoes of the First Flame",
      status: "available",
      npc: "Albus",
      location: "Hearth Hall",
      prerequisites: "Overall Level 10",
      description: `Enter the Hearth Hall for the first time and you'll unlock this quest. It teaches you about each Union. To complete the quest, pick a Union at the sign near Gianno.
      
      <br/><br/>Wildroves = Green = Verdant Yieldstones. Their motto is Awaken the wild within.<br/>
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/WildGrovesLogo.png" alt="wildgroves logo" class="h-10"/>
      <br/>Seedwrights = Yellow = Flint Yieldstones. Their motto is Rise with purpose.<br/>
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/SeedWrightsLogo.png" alt="seedwrights logo" class="h-10"/>
      <br/>Reapers = Red = Hollow Yieldstones. Their motto is Embrace the harvest of shadow.<br/>
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/ReapersLogo.png" alt="reapers logo" class="h-10"/>
      <br/>Pick one that speaks the most to you!`,
      items: ["None"],
      reward: "Tier 1 Yieldstone, 5 Reputation",
      otherinfo: "Oct 30th - Ongoing",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Bountyfall/image_2025-11-03_005617701.png"],
    },
    {
      id: 69,
      name: "Terrorvilla",
      status: "expired",
      npc: "Priya, Karen, Kirby, Miss Peach, Jerome, Goose, Luke, Nellie, Heidi, Sophia",
      location: "Various Locations",
      prerequisites: "None",
      description: `The Halloween Spirit has struck Terra Villa and a new quest was released that requires bringing an item to different NPCs in return for a trick or a treat! You can even win a Pixel Pet as a prize at the end.
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Chat with Priya in the Post Office. She'll ask you for 5 Popberries and give you 1 Umpkin Wine.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Next, go talk to Karen in the HQ (back of Post Office since Chapter 3!) and bring her 1 Whittlewood Plank in return for 1 Basic Axe. (trick)
      <br/><br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Head to the Pet Store and talk to Kirby. She'll want 1 Pet Treat in return for 10 Popberry Seeds.
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Go to Peach next at the Marketplace inside Buck's Galore - 1 Tato Hash for 500 Coins
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Jerome will be in the Decor Store. He wants 1 Silk Cloth, 2 Cow Turds will be your prize.
      <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> Visit Goose in the Drunken Goose with 300 Honey in return for a Sour Power Candy!
      <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> Talk to Luke in the Sauna. He wants 30 Blue Grumpkins. You get 1 Leaky Luke Watering Can.
      <br/><i class="fa-solid fa-8" style="color: #9a7997;"></i> Now find Nellie in the Ministry of Innovation (or the basement of Leon's Neon Zone). She'll request 4 Seaweed in return for 10 Zonez Tokens.
      <br/><i class="fa-solid fa-9" style="color: #9a7997;"></i> Next up, head to Heidi in the Theatre and bring 3 Irontite Ores. You'll get something pink! 10 Salmon Slabs      
      <br/><i class="fa-solid fa-10" style="color: #9a7997;"></i> Finally go to the Bank and chat with Sophia. 15 Clayum Powder gets you 1 Halloween Box.
      <br/>
      <br/>After you chat with Sophia, you'll complete the quest. Click the box on yourself to see if you win or not. You could get 1 Mining Potion, a Copperite Bar, or 1 Pixel Pet Capsule. Happy Halloween and good luck!
      <br/>Image Credit goes to Zombina!`,
      items: ["5 Popberries", "1 Whittlewood Plank", "1 Pet Treat", "1 Tato Hash", "1 Silk Cloth", "300 Honey", "30 Grumpkins", "4 Seaweed", "3 Irontite Ores", "15 Clayum Powder"],
      reward: "1 Umpkin Wine, 1 Basic Axe, 10 Popberry Seeds, 500 Coins, 2 Cow Turds, 1 Sour Power Candy, 1 Leaky Luke Watering Can, 10 Zonez Tokens, 10 Salmon Slabs, 1 Halloween Box, 10 Reputation",
      otherinfo: "Oct 29 2025 - Nov 3 2025",
      image: ["https://pbs.twimg.com/media/G4dyBX9XYAA6hBz.png"],
    },{
      id: 68,
      name: "McKelpy's Treat",
      status: "available",
      npc: "Captain McKelpy, Cod Stewart",
      location: "Pier (South on the Beach)",
      prerequisites: "The Fleet and the Fish, Level 37 Exploration",
      description: `Go chat with Cod Stewart on the right side of the Pier. He'll tell you about a favor he did for McKelpy and he wants to do something nice in return!
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Chat with Cod Stewart. He'll ask you to make one Ocean Breeze Boat.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Gather the ingredients for the boat: 3 Garden Magnifique, 2 Eel Mount and 1 Leafy Crunch
      <br/>
      <br/><i><a href="/lookup/items/itm_wrap_02" target="_blank" rel="noreferrer" class="wiki-links">Garden Magnifique:</a></i> 6 Fluppy (All Lands), 3 H20-My-Cod (Water Lands), 6 Smudgeon (Speck), 9 Fluffgrice
      <br/><i><a href="/lookup/items/itm_nigiri_02" target="_blank" rel="noreferrer" class="wiki-links">Eel Mound</a></i>: 2 Fluppy (All Lands), 4 Stainless Eel (Water Lands), 2 Hot Sauce, 10 Seaweed, 4 Fluffgrice
      <br/><i><a href="/lookup/items/itm_crunch_02" target="_blank" rel="noreferrer" class="wiki-links">Leafy Crunch</a></i>: 3 Seaweed, 1 Speckled Streamer (Pier), 2 Cherroop Goop (Speck), 1 Hot Sauce    
      <br/><br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you've gathered all the ingredients, craft the Ocean Breeze Boat at a Tier 2 Sushi Station and take it to McKelpy!
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> McKelpy will accept the Boat and tell you to relay his thanks to Cod. Walk back to Cod for your reward.`,
      items: ["1 Ocean Breeze Boat"],
      reward: "80 Buoy Bucks, 5 Reputation",
      otherinfo: "Oct 21 2025 - Ongoing",
      image: [],
    },
    {
      id: 67,
      name: "The Fleet and the Fish",
      status: "available",
      npc: "Captain McKelpy, Cod Stewart, Harbormaster",
      location: "Pier (South on the Beach)",
      prerequisites: "None",
      description: `When you walk on the Beach, you'll immediately get a message from Captain McKelpy! Go chat with him on his ship to get the quest started.
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Go into the Ship at the end of the dock. Captain McKelpy will ask you to talk to Harbormaster.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Chat with the Harbormaster who is standing by the Contracts Table on the Pier. 
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> After talking to the Harbormaster, head back to Captain McKelpy. He'll give you 75 Buoy Bucks. 
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Next, go talk to Cod Stewart. He's on the Pier on the right side of the docks. He'll give you a Fishing Rod, and ask you to find 2 Seaweed, 2 Fluppy Fish, 3 Fluffgrice and 11 Orange Grumpkins.
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> When you have all those ingredients, go back to Cod! He'll give you the recipe for the Wiggly Fluppy Nigiri. Use it on yourself and you'll be able to craft the Nigiri in the Sushi Table.
      <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> After crafting the Nigiri, return to Cod. He'll tell you to take the Nigiri to Captain McKelpy
      <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> Chat with McKelpy again on his ship for a reward of 75 more Buoy Bucks (he takes the Nigiri!)`,
      items: ["2 Seaweed", "2 Fluppy Fish", "3 Fluffgrice", "11 Orange Grumpkins"],
      reward: "1 x Fishing Rod & 150 Buoy Bucks & Wiggly Fluppy Nigiri Recipe",
      otherinfo: "Oct 16 2025 - Ongoing",
      image: [],
    },
     {
      id: 66,
      name: "Don't Stop The Beat",
      status: "expired",
      npc: "Goose",
      location: "Drunken Goose",
      prerequisites: "None",
      description: `Search for 50 Terra Beats Tickets scattered around Terra Villa. Bring them back to Goose!`,
      items: ["50 Terra Beats Tickets"],
      reward: "1 Disco Barney & 10 Reputation",
      otherinfo: "Sept 26 2025 - Sept 27 2025",
      image: [],
    },{
      id: 65,
      name: "Nellie's Fun Quest",
      status: "expired",
      npc: "Nellie",
      location: "There's a path right of Kiko. Follow the path",
      prerequisites: "None",
      description: `Search for 100+ candy on the new map! (which is really an old map) There's 106 Candy scattered around but 100 is enough to finish the quest. Talk to Nellie who is in the center of the map, and she will reward you.`,
      items: ["100+ Special Candy"],
      reward: "30 Infiniportables",
      otherinfo: "Sept 3 2025 - Sept 8 2025",
      image: [],
    },
    {
      id: 64,
      name: "Guardians of the Fields",
      status: "available",
      npc: "Gurney",
      location: "Inside the Sauna",
      prerequisites: "Level 10 Woodworking, Patience Meets Pancakes",
      description: `Gurney says he needs more help for his fields. 2 Scarecrows to scare off the crows. This quest provides the scarrots, so no worries on the beginner friendliness!
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Chat with Gurney to get the quest. He'll ask you for 2 Scarecrows. Easy enough!
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Each scarecrow needs 12 Sticks, 24 Scarrots, 6 Blue Grumpkins, 6 Whittlewood Planks and 3 Hay Stack Medium.
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Sticks can be crafted at a Woodworking Station, the Scarrots are Given to you, Blue Grumpkins grow from seeds, Planks can be made at the Woodworking Station and you get the hay stacks from the decor store.
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Once you've got all the ingredients, craft 2 Scarecrows at the Woodworking Station and take them back to Gurney
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Gurney rewards you at the end for completing this and all the quests. He gives you reputation!
      
      <br/><br/>Remember to place your Trinket Shelf inside your house and place all your trinkets on the shelf! They turn into a nice quest shelf that showcases your completion.`,
      items: ["24 Sticks", "48 Scarrots", "12 Blue Grumpkins", "12 Whittlewood Planks", "6 Hay Stack Medium", "Turn those into 2 Scarecrows"],
      reward: "Golden Scarecrow, Scarecrow Trinket, 150 Reputation",
      otherinfo: "Aug 28th 2025 - Ongoing",
      image: [],
    },{
      id: 63,
      name: "Patience Meets Pancakes",
      status: "available",
      npc: "Kiko",
      location: "Outside of the Guild Hall on the right side",
      prerequisites: "Level 11 Cooking, A Strange Scent in the Air",
      description: `Kiko wants some Kiko Pancakes (his special craving) - craft pancakes for Kiko!
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First chat with Kiko so he can request the pancakes
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need 4 Popberries, 3 Grainbow Flour, 2 Eggs and 1 Cow Milk to craft Kiko's Popberry Pancakes
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> You can grow the Popberries in soil and craft the Grainbow Flour at a windmill. For the eggs, you need to have chickens on a coop (and collect the eggs) and for the Cow Milk, you will need to feed a lot of cows. Milk is a rare drop. For each feeding, you need 6 Moo Munch! Try a land with many cows.
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Once you've got all the ingredients, craft Kiko's Popberry Pancakes at the stove
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Return to Kiko to complete the quest`,
      items: ["4 Popberries", "3 Grainbow Flour", "2 Eggs", "1 Cow Milk", "Turn those into Kiko's Popberry Pancakes"],
      reward: "Pancake Trinket and a Pancake Stool",
      otherinfo: "Aug 28th 2025 - Ongoing",
      image: [],
    },{
      id: 62,
      name: "A Strange Scent in the Air",
      status: "available",
      npc: "Margaret",
      location: "Inside the Bank",
      prerequisites: "Level 6 Cooking, A Little Rainbow in a Bottle",
      description: `Margaret is craving a Popberry Loaf. Bring one for her
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First chat with Margaret to get her request for the Popberry Loaf
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Craft a Popberry Loaf at any stove using 3 Popberry Jams and 2 Grainbow Flour (Flour from the Mill, Jams from the stove)
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Chat again with Margaret once you've got the loaf and she'll complete your quest`,
      items: ["3 Popberry Jam", "2 Grainbow Flour", "Turn those into a Popberry Loaf"],
      reward: "Popberry Trinket",
      otherinfo: "Aug 28th 2025 - Ongoing",
      image: [],
    },{
      id: 61,
      name: "A Little Rainbow in a Bottle",
      status: "available",
      npc: "Sandy, Ed, Winona",
      location: "Top left of Fountain - Left of Pixels HQ",
      prerequisites: "Level 5 Business, Working With Metal",
      description: `Sandy teaches you about crafting bottles. They're used for wines. Ed will guide you on the other components of your wine. Winona will ask you to craft that final wine bottle!
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First speak with Sandy. She will ask you to bring back a wine bottle. For that, you need 4 Glass and/or 8 Gravelglass Matrix to make the Glass!
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Bring the finished Glass Bottle (craft it at the Stoneshaping Kit near her, or any) and Sandy will send you off to Ed!
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Talk to Ed who is right of the Pixel HQ next to the Slug Hutch. He'll ask you to bring Honey and Slime     
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> You can get Honey from Bees and Slime from Slugs. Slime needs level 2 Animal Care and it's a random drop so you don't always get it!     
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Once you've got the Honey and Slime, talk to Ed again. He'll send you to Winona     
      <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> Talk to Winona at the bottom left of Terra Villa (she's near the Bar). Winona will ask you to craft a Grainshine.
      <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> Recipe of Grainshine: 8 Grainbow, 10 Cooking Mix, 3 Honey, 1 Silk Slug Slime and 1 Glass Bottle. You should have the honey, slime, and glass bottle.
      <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> You can grow Grainbows from Grainbow Seeds bought at Buck's Galore, and the Cooking Mix can also be purchased from Buck's Galore (recommended to not buy from Marketplace because players overprice it!)
       <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> Craft the Grainshine at the Winery next to Winona then take it back to Winona. She'll finish up the quest for you and give you a reward!`,
      items: ["8 Grainbow", "10 Cooking Mix", "3 Honey", "1 Silk Slug Slime", "1 Glass Bottle", "Turn those into a Grainshine"],
      reward: "Cork Trinket",
      otherinfo: "Aug 28th 2025 - Ongoing",
      image: [],
    },{
      id: 60,
      name: "Working With Metal",
      status: "available",
      npc: "Smith",
      location: "Top right of Fountain - Right of Pixels HQ",
      prerequisites: "Level 1 Metalworking, A Place for Everything, That's So Metal!",
      description: `Craft a Magnifying Glass so Smith can look deeper into some funny gems he's been finding!
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First speak with Smith. He'll give you the quest.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Gather 4 Copperite Ore and 1 Gravelglass Matrix from the Mines. Take them to Smith first.
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Smith asks you to craft the Magnifying Glass out of the materials you got! Use the Metalworking Bench next to him      
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Take the Magnifying Glass to Smith. He'll end the quest and reward you`,
      items: ["4 Copperite Ore", "1 Gravelglass Matrix", "Turn those into a Basic Magnifying Glass"],
      reward: "Gear Trinket",
      otherinfo: "Aug 28th 2025 - Ongoing",
      image: [],
    },
    {
      id: 59,
      name: "A Place For Everything",
      status: "available",
      npc: "Jack",
      location: "Left of Fountain",
      prerequisites: "Level 5 Woodworking, Shoulda, Wood-a, Coulda! Quest",
      description: `Jack says you don't have to store everything in your bag. Learn how to make a storage chest!
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First speak with Jack. He'll give you the quest.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Get 4 Planks, and 2 Glue then craft a Whittlewood Chest at any Woodworking Bench. (One is next to Jack).
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Chat with Jack once you've got the chest and he should complete the quest for you!`,
      items: ["4 Planks", "2 Glue", "Turn those into a Whittlewood Chest"],
      reward: "Hammer Trinket, Empty Trinket Shelf",
      otherinfo: "Aug 28th 2025 - Ongoing",
      image: [],
    },
    {
      id: 58,
      name: "Cure for the Bees",
      status: "available",
      npc: "Alina, Penny, Jill, Amy",
      location: "Red Lamp on the Right side of the Theater",
      prerequisites: "Level 20 Animal Care, The Alchemist's Concoction Quest",
      description: `Help Alina save the bees! They seem to be suffering from a curse that is turning their honey poisonous. Alina has requested our help to find three items: A Deep Moss Agate, Aged Ironwood Bark, and a Sun-Kissed Ambrosia Recipe. 
      <br/>Different NPCs have the items, but we need to convince them to give us the items.
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First speak with Penny. She's in the Pet Shop in the back. Get her 90 Bedrock Matrix. She'll give you the Deep Moss Agate in return for the Matrix.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Second, speak with Jill by the Woodworking Bench (left of the fountain) who will ask for 4 Silk Cloth in return for the Aged Ironwood Bark (which she actually gets from Jack)
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Third, speak with Amy (she's on the far right by the Apiary) who needs 2 Tangy BBQ Sauce in exchange for the Recipe.
      <br/><br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> When you have all three items, return to Alina. She'll mix them together and then realize she's still missing one final piece. 4 Aether Fruit.
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> She will give you the Terra Bloom Elixir (which you made previously in her other quest). Use it on an Aether Tree (which you also received previously)
      <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> Collect the 4 Fruit that'll drop from the Aether Tree and take them back to Alina to finish the quest. She'll give you 1 Beekeeper Box (decor) and a Bulk Moomunch Recipe.`,
      items: ["90 Bedrock Matrix", "4 Silk Cloth", "2 Tangy BBQ Sauce"],
      reward: "1 Beekeeper Box, 1 Bulk Moo Munch Recipe, 150 Reputation",
      otherinfo: "Aug 14th 2025 - Ongoing",
      image: [],
    },
    {
      id: 57,
      name: "Mullet Melon Protocol",
      status: "expired",
      npc: "Luke",
      location: "New Beach",
      prerequisites: "None",
      description: `For three days, search for Mullet Melons scattered around Terra Villa and the Beach to unlock a prize each day!
      <br/>Each day completed earns you another 10 Reputation and a Leaky Luke Watering Can. The Watering Can waters 3 x 3 Tiles up to 60 times.`,
      items: ["None"],
      reward: "30 Reputation, Leaky Luke Watering Can",
      otherinfo: "Aug 8 - Aug 10 2025",
      image: [],
    },
    {
      id: 56,
      name: "Welcome to Leon's Neon Zone!",
      status: "available",
      npc: "Manager Artie, Buffy, Bart, Gamemaster Flaster, Neon Leon",
      location: "Leon's Neon Zone",
      prerequisites: "None",
      description: `<i class="fa-solid fa-1" style="color: #9a7997;"></i> Talk to Manager Artie, who will start you off on a tour of the Neon Zone. He directs you to speak to Buffy and Bart.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Speak with Buffy and Bart (the order doesn't matter). One will explain about Stuff Stubs and the redemption shop.
      <br/>The other will teach you about buying Zonez Tokens.
      <br/><br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> After you chat with Buffy and Bart, speak with Artie again! He'll tell you to talk to Gamemaster Flaster who is a little further up.
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i>Flaster will explain everything about the leaderboards on the walls, then directs you to talk to Neon Leon.
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Neon Leon will explain about the Fortune Teller and what to feed it. He even tells you to get the Doubloons from the Vaporwheel.`,
      items: ["None"],
      reward: "20 Zonez Tokens",
      otherinfo: "Aug 5 2025 - Ongoing",
      image: [],
    },
    {
      id: 55,
      name: "The Pull Beneath Our Feet",
      status: "available",
      npc: "Bitsy, Jack, Ed",
      location: "Ministry of Innovation",
      prerequisites: "Shoulda, Wood-a, Coulda!, Level 30 MW, Level 30 SS",
      description: `Something strange is happening in the land. Help Bitsy, Ed and Jack figure out the strange happenings in the grasslands.
      <br/><br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First, head to Bitsy in the Ministry of Innovation (bottom left of the Fountain)
      <br/><br/><i class="fa-solid fa-2" style="color: #9a7997;"></i>Talk to Bitsy to start the quest! She tells you about strange things happening, and to look into it
      <br/>-------She'll ask you to bring her 4 Magnetite Ore and 6 Magnoot. You can get these from planting the new Magnoot Seeds from Buck's Galore, and getting Magnetite Ore from Grassland Mines (T2 and up)
      <br/><br/><i class="fa-solid fa-3" style="color: #9a7997;"></i>When you have the Magnetite and Magnoot, go back to Bitsy. She'll give you a Magnet Recipe
      <br/>-------Remember to use the recipe on yourself (EAT IT)
      <br/><br/><i class="fa-solid fa-4" style="color: #9a7997;"></i>Go to a Tier 2 or higher Metalworking Bench and Craft a Magnet using 4 Magnetite Ore and 2 Construction Powder
      <br/><br/><i class="fa-solid fa-5" style="color: #9a7997;"></i>When you've finished crafting the magnet, go to Ed. Ed is top right of the fountain near the slug hutch.
      <br/><br/><i class="fa-solid fa-6" style="color: #9a7997;"></i>After you talk to Ed, he explains to you his findings from the Magnet and tells you to chat with Bitsy again!
      <br/><br/><i class="fa-solid fa-7" style="color: #9a7997;"></i>Go back to Bitsy. She'll ask you to chat with Jack next!
      <br/><br/><i class="fa-solid fa-8" style="color: #9a7997;"></i>Jack will be at the woodworking bench left of the fountain. He asks you to get 6 Magnoot, 12 Screws and 6 Craftbark Planks
      <br/><br/><i class="fa-solid fa-9" style="color: #9a7997;"></i>Take the items back to Jack for a special Magnoot Fence Recipe. He'll ask you to craft it and take the finished fence to Bitsy.
      <br/>------Eat the recipe again!
      <br/><br/><i class="fa-solid fa-10" style="color: #9a7997;"></i>Go to a woodworking bench Tier 2+ or higher and craft the Fence using the ingredients you gathered
      <br/><br/><i class="fa-solid fa-11" style="color: #9a7997;"></i>Take the Fence to Bitsy to complete the quest and get your reward.
      `,
      items: ["4 Magnetite Ore", "6 Magnoot", "2 Construction Powder", "12 Screws", "6 Craftbark Planks"],
      reward: "Maggie Flowers (Decor), 25 Reputation",
      otherinfo: "July 25th, 2025 - Ongoing",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/grassland+update.png"],
    },
    {
      id: 54,
      name: "Moki's Birthday 2025",
      status: "expired",
      npc: "Hantao",
      location: "Eggu Island",
      description: `Turn in Moki Snacks for a Moki Ball from Hantao and a chance at winning great prizes! You need to turn in 4 balls to complete the quest and get the rep, but completing one snack is enough to get you a prize.
      <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i>Talk to Hantao to start the quest.
      <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i>Buy 25 Seeds from the machine behind him. It resets at 12 AM UTC every day but the limit is 25
      <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i>Plant the Seeds (They take 2 hours to grow). Then return with the seeds to Eggu Island
      <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i>With 100 Popberries, 5 Cooking Mix and the Sparkle Fruit, craft a Moki Snack
      <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i>The Moki Snack takes 30 minutes to complete. When it's finished click it on Hantao for a Moki Ball prize!
      <br/>Turn in 4 Snacks total to complete the quest.`,
      items: [],
      reward: "Moki Balls (chance of Moki NFT, Moki event prizes, tools, energy drinks, and more) + 50 Reputation",
      otherinfo: "June 17 - June 21, 2025 ",
      image: [],
    },{
      id: 53,
      name: "Merchant Mandate",
      status: "expired",
      npc: "Heidi",
      location: "Beach",
      description: `Craft 🍸 15 Shorelimeades for Heidi for the Very Important Merchant.<br/>
      You could craft as many shorelimeades as you'd like out of two different recipes:
      <br/>One recipe for 25 Shorelimes and 2 Shorelemons (70 Energy)
      <br/>The other recipe for 520 Shorelimes (10 Energy)
      <br/><br/>Every 🍸 15 Shorelimeades = 💫 1 Star.
      <br/>💫 Every star = 1 Prize up to 6. After 6 stars, it's just an entry in the raffle.`,
      items: [],
      reward: "200 Reputation, Shorelime Suit (3 different ones), Shorelime Lantern, T2/T3/T4 Tools and 12 Butterbrew",
      otherinfo: "June 20 2025",
      image: [],
    },
    {
      id: 52,
      name: "The Alchemist's Concoction",
      status: "available",
      npc: "Alina",
      location: "Red Lamp on the Right side of the Theater",
      prerequisites: "Level 25 Cooking",
      description: `An Alchemist needs your help to solve a string of riddles in order to get the Terra Bloom Elixir and restore her trees.
      <br/>For this, you need to solve 10 Riddles from Alina to figure out each item needed for the Alchemical Reaction
      <br/><br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> First, visit Alina in her secret room (Right side of the Theater). 
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Guide+Images/image_2025-06-09_030317174.png" alt="alina location" class="h-48"/>
      <br/>You will need to speak to Alina to answer each riddle first. She gives you 10 item riddles where she wants you to bring an item that solves the riddle..
      <br/>You can get all the items in advance (See Required Items) and solve each riddle with the items in your bag.
      <br/><br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> When you're done solving all of the riddles, Alina will give you one final riddle which is the ORDER the items must go in the Cauldron.
      <br/>Go to the cauldron on the right of Alina and place the items in this order: 
      <br/>Copperite Nail ➡️ Turkey Feather ➡️ Honey ➡️ Popberry Pie ➡️ Sap ➡️ Clayum Powder ➡️ Four-Leaf Clover ➡️ Seltsam Egg ➡️ Sawdust ➡️ Orchrux Matrix 
      <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Guide+Images/image_2025-06-09_030043961.png" alt="cauldron" class="h-32"/><br/><br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> You should get 1 Terra Bloom Elixir. If you got Sludge, you did not put the items in the right order and you need to do it again!
      <br/><br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Return to Alina and give her the Elixir to be rewarded.`,
      items: ["4-Leaf Clover", "Popberry Pie", "Sawdust", "Copperite Nail", "Honey", "Turkey Feather", "Sap", "Seltsam Egg", "Orchrux Matrix", "Clayum Powder"],
      reward: "25 Reputation, Aetherbloom Tree Decor, and a Barrel of Clover Jam Recipe",
      otherinfo: "May 29th, 2025 - Forever",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Guide+Images/image_2025-06-09_030032152.png"],
    },
    {
      id: 51,
      name: "Croaking The Tunes Of Forgotten Runes",
      status: "expired",
      npc: "Hedge Wizard Dotta ",
      location: "Central TV below the fountain",
      description: `Objective is to find the Frog Lanterns scattered all around Terra Villa. There will be 30 in total.<br/>
      The team places 5 Frog Lanterns each day (6 days in total). Find them by using your game audio, as they make noise and can lead you to where they're hidden!<br/>
      <br/>
      Once you've found all 30, turn them in to Hedge Wizard Dotta for a fun surprise.<br/>
      Follow along with various content creators as they find them on the fly!<br/>
      <br/>
      Upon collecting 30 frogs, you'll be teleported to a small map! You'll get your reward. Click on the flame to collect it and leave the map.<br/>
      Make sure you have space in your bag before being teleported!`,
      items: ["30 Lantern Frogs"],
      reward: "Sacred Flame Statue, Lantern Frog Statue, 100 Reputation",
      otherinfo: "May 5th - May 11th, 2025",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/forgottenruniversefinal.png"],
    },
    {
      id: 50,
      name: "Sophia's Easter Egg Hunt",
      status: "expired",
      npc: "Sophia",
      location: "Left of Buck's Galore",
      description: `Sophia dropped all of her easter eggs from her basket!<br/>
        It's up to us to locate all of them (some of which are on Top Farms). Find all the eggs in various locations, then return to Sophia for your prize!<br/>
        Here's a full list of locations (with the help from the discord):
        Message quoted from CruxKill in the Pixels server:
        <br/> ➡️ 62 in Terra Villa Central (or main TV)
        <br/> ➡️ 2 in Sauna
        <br/> ➡️ 4 in Buck's Galore
        <br/> ➡️ 7 in Petshop
        <br/> ➡️ 4 in Decor Store
        <br/> ➡️ 2 in Bank
        <br/> ➡️ 3 in Bank Basement
        <br/> ➡️ 2 in Post Office
        <br/> ➡️ 2 in Ministry of Innovation
        <br/> ➡️ 8 in the Beach (upper Beach, Shores, the Docks and the Captain Ship)
        <br/> ➡️ 7 at pixels HQ
        <br/> ➡️ 1 at Drunken goose
        <br/> ➡️ 3 Outside the Guild Hall
        <br/> ➡️ 2 Inside the Guild Hall
        <br/> ➡️ 2 Spore Sports Lobby
        <br/> ➡️ 1 Left Rainbow Road
        <br/> ➡️ 2 near the Football Field 
        <br/> ➡️ 3 at Carnival
        <br/> ➡️ 1 in Skate Rink (North Carnival)
        <br/> ➡️ 1 On Santa's Speck
        <br/> ➡️ 1 on each of these lands: 2655, 4051, 3838, 2781, 3761, 270, 4172, 3685, 4076, 2699, 1648, 4993, 660, 4666, 1597, 220, 2977, 450, 264, 1437, 848, 1687, 2141, 971, 957, 1106, 1535, 3885, 3374, 4449, 343`,
      items: ["150 Easter Eggs"],
      reward: "Easter Bunny Statue 2025",
      otherinfo: "April 16, 2025 - April 22, 2025",
      image: [],
    },
    {
      id: 49,
      name: "Captain McKelpy: Marine Elite Of The Merchant Fleet",
      status: "available",
      npc: "Captain McKelpy",
      location: "Beach inside the lowest ship",
      description: `Talk to Captain McKelpy to get the quest then go and talk to the Hardbormaster to complete the quest. It's really simple and doesn't really offer much.`,
      items: ["None"],
      reward: "None",
      otherinfo: "April 2nd, 2025",
      image: [],
    },
    {
      id: 48,
      name: "Jorge's Harvest Hustle",
      status: "expired",
      npc: "Jorge Grassias",
      location: "Harvest Hustle Map",
      description: `Jorge requires multiple crafted items to aid him with his competition. He asks you to craft 5 Harvest Hustle Haystacks and in return, you will receive 1 Harvest Hustle Hay Bale.<br/>
        After you bring him 5 Harvest Hustle Haystacks, he'll ask you to bring him 5 Harvest Hustle Wheelbarrows. The reward for this will be 1 Harvest Hustle Cart.<br/>
        Once you've completed the Wheelbarrows, he'll then ask you to bring 5 Harvest Hustle Rakes. The final reward will be the Harvest Hustle Western Wear (complete with hat!)<br/>
        You'll be able to keep and deposit all of these items into the Well for the leaderboard event also happening!`,
      items: ["35 Harvest Hay", "10 Silk Rope", "25 Copperite Screws", "50 Irontite Bars", "20 Whittlewood Logs", "75 Energy"],
      reward: "1 Harvest Hustle Hay Bale, 1 Harvest Hustle Cart & 1 Harvest Hustle Western Wear",
      otherinfo: "March 4th - March 9th 2025",
      image: [],
    },
    {
      id: 47,
      name: "Valentino, The Love Neutrino, Puts The Petal To The Metal!",
      status: "expired",
      npc: "Valentino",
      location: "Valentine Hut - Located Left of Fountain",
      description: `Valentino wants to present a bouquet of roses for Esme. He needs your help to gather the roses!
        <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Speak to Valentino to acquire the quest. He will ask you to gather the ingredients to craft at the Ardor Augmentation Apparatus.
        <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need 50 Heartbeets, 30 Honey, 50 Fertilizer and 120 Heartbeet Roses. 
        <br/><br/> ➡️ To get the Heartbeet Seeds, you can buy 1 per day in the store for 6,000 Coins each. You can also get seeds by participating in the Regular Heartbeet Hoedown (every 24h). You will need to plant these for heartbeets.
        <br/> ➡️ For Honey, you can get these from Apiaries (you will need to buy a Queen Bee in the Pet Shop and place on an apiary) or from the marketplace
        <br/> ➡️ For Fertilizer, you can buy these in the store for 20 Coins, or craft them at a Composter (see Animal Care in Skills) or from the marketplace (Total: 1,000 Coins)
        <br/> ➡️ And for the Roses, you can get these from the Premium Heartbeet Hoedown (every 8h) - for this you will need the Heartbeet Hoedown Token <img src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_heartbeettoken/2cafad5e-c834-4762-ba4f-00b7d6b797a3.png" alt="token" class="h-6 inline"/>
        <br/> <img src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_heartbeettoken/2cafad5e-c834-4762-ba4f-00b7d6b797a3.png" alt="token" class="h-6 inline"/> The Premium Ticket lasts for 21 Uses and each round lasts for 1 minute. You get both Cubes and Roses on a win (half andf half)
        <br/><br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you have acquired all the materials, craft the item at the Ardor Augmentation Apparatus
        <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Return to Valentino with the complete item (which takes 3 hours and costs 10 energy and grants 500 Farming EXP)
        <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Valentino will reward you with a special prize!`,
      items: ["50 Heartbeets", "30 Honey", "50 Fertilizer", "120 Heartbeet Roses"],
      reward: "50 Reputation & Loverboy Suit",
      otherinfo: "Feb 14 2025 - Feb 21 2025",
      image: [
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-14_100307546.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-13_162739788.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-13_162824304.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-13_164828398.png",
      ],
    },
    {
      id: 46,
      name: "Confections With Esme Bring Affections Your Way!",
      status: "expired",
      npc: "Esme",
      location: "Valentine Hut - Located Left of Fountain",
      description: `Esme wants to present a box of chocolates for Valentino, but she can't do it alone! She needs your help.
        <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Speak to Esme to acquire the quest. She will ask you to gather the ingredients to craft at the Ardor Augmentation Apparatus.
        <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need 50 Heartbeets, 30 Honey, 100 Cooking Mix and 120 Heartbeet Sugar Cubes. 
        <br/><br/> ➡️ To get the Heartbeet Seeds, you can buy 1 per day in the store for 6,000 Coins each. You can also get seeds by participating in the Regular Heartbeet Hoedown (every 24h). You will need to plant these for heartbeets.
        <br/> ➡️ For Honey, you can get these from Apiaries (you will need to buy a Queen Bee in the Pet Shop and place on an apiary) or from the marketplace
        <br/> ➡️ For Cooking Mix, you can purchase these from Buck's Galore for 10 Coins Each (Total: 1,000 Coins)
        <br/> ➡️ And for the Sugar Cubes, you can get these from the Premium Heartbeet Hoedown (every 8h) - for this you will need the Heartbeet Hoedown Token <img src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_heartbeettoken/2cafad5e-c834-4762-ba4f-00b7d6b797a3.png" alt="token" class="h-6 inline"/>
        <br/> <img src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_heartbeettoken/2cafad5e-c834-4762-ba4f-00b7d6b797a3.png" alt="token" class="h-6 inline"/> The Premium Ticket lasts for 21 Uses and each round lasts for 1 minute. You get both Cubes and Roses on a win (half andf half)
        <br/><br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you have acquired all the materials, craft the item at the Ardor Augmentation Apparatus
        <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Return to Esme with the complete item (which takes 3 hours and costs 10 energy and grants 500 Cooking EXP)
        <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Esme will reward you with a special prize!`,
      items: ["50 Heartbeets", "30 Honey", "100 Cooking Mix", "120 Heartbeet Sugar Cubes"],
      reward: "50 Reputation & Lovergirl Gown",
      otherinfo: "Feb 14 2025 - Feb 21 2025",
      image: [
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-14_100307546.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-13_162739788.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-13_162833106.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-02-13_164828398.png",
      ],
    },
    {
      id: 45,
      name: "2025 Lunar New Year!",
      status: "expired",
      npc: "Auntie May",
      location: "Terra Villa",
      description: `
        <i class="fa-solid fa-1" style="color: #9a7997;"></i>Talk to Auntie May every day to get Cabbabage Seeds. You get 1 if you're less than 2,000 Rep. And 24 if more than 2,000 Rep.
        <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Plant the Cabbabage Seeds and harvest them for full grown Cabbabages.
        <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> When you're done growing them, talk to Auntie May!
        <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> She will then ask you to bring her dumplings. Each dumpling you provide, Auntie May will give you 1 Envelope.
        <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> If you're VIP, you can craft 6 Steamed Dumplings at a time in the Steamer! Otherwise, only 1 at a time.
        <br><img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/Auntie+May.png" class="w-48" />
        <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> When you're finished crafting the dumplings (30m each or 3h for the batch of 6), talk to Auntie May!
        <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> Auntie May will give you an envelope for each dumpling you give to her. Use them on youself and load up on prizes!
        <br/><br/>🐍 If you are above 2k Rep, you will receive a Gold Envelope.
        <br/>🐍 If you are below 2k Rep, you will receive a Red Envelope.
        <br/>🐍 Each envelope has prizes that you can win!

        <br/><br/>💌 Possible Prizes:<br/>Lunar New Year Snake Pet\n<br/>Lunar New Year Accessories
        <br/>🐉🐉2025 Lunar New Year Guanmao
        <br/>🐉🐉2025 Lunar New Year's Ornamental Hairstyle
        <br/>🐉🐉2025 Lunar New Year's Gorgeous Gown
        <br/>🐉🐉2025 Lunar New Year's Tangzhuang
        <br/>Lunar New Year Treats<br/>Lunar New Year Stoneshaping Boost Sculptures`,
      items: ["Cabbabage Seed, 1 Lunar Eggs, 1 Turkey Egg, 2 Seltsam Eggs"],
      reward: "Red or Gold Envelope with various prizes (see above)",
      otherinfo: "Jan 29, 2025 - Feb 5, 2025",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/image_2025-01-29_014805160.png"],
    },
    {
      id: 44,
      name: "Search for Moki Snacks",
      status: "expired",
      npc: "Hantao",
      location: "Decor Store - In Front",
      description: `Moki is not a great driver and may have gotten into an accident. Need to locate all 11 snacks for Moki Pochi (Hantao). Locate the 11 Treats!\n
        <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Land 119
        <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Football Field Near Giraffe\n
        <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Football Field Near the 30 Line\n
        <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Carnival Behind the Bee Trailer\n
        <br/><i class="fa-solid fa-5" style="color: #9a7997;"></i> Carnival on the Car Track\n
        <br/><i class="fa-solid fa-6" style="color: #9a7997;"></i> One on the far left side of the Pier (Beach)\n
        <br/><i class="fa-solid fa-7" style="color: #9a7997;"></i> One in the bushes on the right (Beach)\n
        <br/><i class="fa-solid fa-8" style="color: #9a7997;"></i> Terra Villa next to the Theater (Left)\n
        <br/><i class="fa-solid fa-9" style="color: #9a7997;"></i> Terra Villa Left of Goose Bar\n
        <br/><i class="fa-solid fa-10" style="color: #9a7997;"></i> Guild Castle far top right corner (outside)\n
        <br/><i class="fa-solid fa-11" style="color: #9a7997;"></i> Ministry of Innovation \n\n
        <br/><br/>When you've found all of the Treats, go back to Hantao to finish the quest!
        `,
      items: ["None"],
      reward: "1/5 Chance to win a Moki NFT - 1/5 Chance to win a Moki UGC",
      otherinfo: "Nov 27 2024 - Nov 29 2024",
      image: [],
    },
    {
      id: 43,
      name: "Gabby's YGG Gourd",
      status: "expired",
      npc: "Gabby",
      location: "YGG Arena",
      description: `Gabby says: The Capricious Catering Co. we hired to cook our traditional spaghetti gourd pasta for the Summit Summation Supper fell through on us. Go figure! <br/>
        I need to grow gobs of YGGourds in the next 5 days to guarantee these gamers can gorge their gullets until they’re fully gratified!<br/>
        <br/>You'll be growing YGGourds for 5 days in a row to complete this quest!<br/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Head to the bus stop that is left of the fountain and click on it! You will be instantly transported to the YGG Play Summit Arena<br/>
        <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B5D259BAC-2404-4FF3-9396-00F3505ACCE0%7D.png" alt="Bus Stop" height="300"/><br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You should get the quest upon entering the building. Grow 50 YGGourds per day to earn a PixTix/day<br/>
        <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BE8BE7FD7-EBAF-4A08-BB91-5A4C062EBEA0%7D.png" alt="Bus Stop" height="300"/><br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Walk around to each of the booths to collect seeds from different vendors. You collect every 24 hours from the last time you collected. <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> When you have all 50 seeds, plant them in the YGG logo in the center and wait 5 minutes <br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i> Harvest the YGGourds and return to Gabby with the YGGourds. He will give you 1 PixTix<br/>
        <i class="fa-solid fa-6" style="color: #9a7997;"></i> When all 5 days have completed, the quest will be marked as "Completed"<br/><br/>
        At the end, you will receive 2 additional PixTix for a total of 6 PixTix.<br/>`,
      items: ["325 Energy to plant, water and harvest the seeds each day"],
      reward: "6 PixTix",
      otherinfo: "Live Nov 18 2024 - Nov 23 2024",
      image: [
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BF13E7271-B6B7-41B9-A5DC-1284C8CA32A9%7D.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BEA929F3B-9965-4BA9-A32A-4865E5063D28%7D.png",
      ],
    },
    {
      id: 42,
      name: "$SUPER Star: Trades for Shades!",
      status: "expired",
      npc: "Ellio",
      location: "$SUPER Trailer",
      description: `Ellio asks you for 9 $SUPER stats that he'll trade for some $SUPER shades. <br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Deposit 10 $SUPER into the game - The game will take 1 for Deposit fees<br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You can purchase $SUPER from Uniswap, Binance, Coinbase or Direct from MM<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Head to the trailer top left of Terra Villa (right of the Windmill) <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> Talk to Ellio who will give you the quest, and ask you to buy $SUPER stars<br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i> Click the Star Trophy top right and purchase 9 $SUPER stats<br/>
        <i class="fa-solid fa-6" style="color: #9a7997;"></i> Talk to Ellio who will give you the quest, and ask you to buy $SUPER stars<br/>
        <i class="fa-solid fa-7" style="color: #9a7997;"></i> Head to the right side of the room, in the corner and buy the 9 $SUPER Stars<br/>
        <i class="fa-solid fa-8" style="color: #9a7997;"></i> Talk to Ellio again and he will reward you with the Shades<br/>`,
      items: ["9 $SUPER tokens - Gas very expensive"],
      reward: "$SUPER Slick Shades & Reputation",
      otherinfo: "Live Nov 6 2024 - Nov 8 2024",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B5F567BE0-C04B-4CAD-B971-83F4617BACEA%7D.png"],
    },
    {
      id: 41,
      name: "Binance Blockchain Week: Binance Swirl Twirl!",
      status: "expired",
      npc: "Rachel",
      location: "Binance Map",
      description: `Gather Ingredients for Rachel to create a special ice cream flavor! Enter the Binance Map to start the quest!<br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> You will need to collect milk, a cone, and both the yellow and black mixes from NPCs around the arena!<br/>
        - Kenny Li has the Yellow Scoop<br/>
        - Eowyn Chen has the Black Scoop<br/>
        - Alex Dreyfus has the Cone<br/>
        - Jason Bitbender has the Milk
        <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Craft the Binance Swirl at the Ice Cream Machine top right of the Binance Map
        <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> Take the Ice Cream to Rachel at the bottom right, who will reward you with 3 PixTix.
        <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Use the teleport behind Heidi to revisit Terra Villa, and select another prize from the Binance Trailer`,
      items: ["None"],
      reward: "3 PixTix to claim a prize from the trailer",
      otherinfo: "Live October 30th 2024",
      image: [
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Event+Screenshots/%7B07D0F2E2-1F15-4ECA-BAEE-2A922562746D%7D.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Event+Screenshots/%7BF87FAE59-D511-469A-A58E-2BC1A1A5687D%7D.png",
      ],
    },
    {
      id: 40,
      name: "Binance Blockchain Week: Block Party!",
      status: "expired",
      npc: "Richard Teng",
      location: "Binance Map",
      description: `Find 12 Binance Blocks scattered around the arena and bring them to Richard so he can connect them into a Binance Chain. Deliver the chain to Heidi to claim your PixTix!<br/>
        A chance to earn more PixTix!
        <br/><i class="fa-solid fa-1" style="color: #9a7997;"></i> Search inside and outside of the Binance Map for all 12 of the Binance Blocks. Two are outside by the tables on the left side. All the others are inside.
        <br/><i class="fa-solid fa-2" style="color: #9a7997;"></i> Talk to Richard again when you've found all 12. He will connect the Blocks and give you back a chain.
        <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i> After you get the chain, talk to Heidi who will reward you with 3 PixTix.
        <br/><i class="fa-solid fa-4" style="color: #9a7997;"></i> Use the teleport behind Heidi to revisit Terra Villa, and select another prize from the Binance Trailer`,
      items: ["None"],
      reward: "3 PixTix to claim a prize from the trailer",
      otherinfo: "Live October 29th 2024",
      image: [],
    },
    {
      id: 39,
      name: "Binance Blockchain Week: Heidi's Swag Bag",
      status: "expired",
      npc: "Heidi",
      location: "Binance Map",
      description: `Collect the 7 different swag items from the sponsor booths and return to Heidi for some PixTix to use to purchase an item in Terra Villa. Also for a chance to win an NFT Land!<br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Upon entering the Stadium, you will automatically receive the quest from Heidi to acquire the Swag. Talk to Vendors inside the Stadium
        <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/Vendors.png" alt="Vendors" width="700"/>
        -- Lily Liu will give you the Solana Sunny's<br/>
        -- JP Mullin will give you a Manta Bucket Hat<br/>
        -- JP Thor will give you a Thorchain Water Bottle<br/>
        -- Vincent Chok will give you a First Digital Business Card<br/>
        -- Dom Schiener will give you an Iota Shirt<br/>
        -- 9GAGCEO will give you a Memeland Keychain<br/>
        -- Regen Rene (who is more to the left side) will give you a Celo Coffee Mug<br/><br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> After you have collected all of these items, head back to Heidi. She will give you 3 TixPix to use at the Binance Trailer in Terra Villa<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Use the Teleport behind her and head to the Trailer. You'll be able to choose from 3 different items. Pick whichever one catches your eye! `,
      items: ["None"],
      reward: "3 PixTix to claim a prize from the trailer",
      otherinfo: "Live October 24th 2024",
      image: [
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B3F403049-E414-4500-8466-2E55EE56CEEF%7D.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B77965427-6375-4F3D-A282-5FBBD5590593%7D.png",
      ],
    },
    {
      id: 38,
      name: "Deranged Dental Exchange",
      status: "expired",
      npc: "Denis the Dentist",
      location: "Guild Hall Interior",
      description: `Denist the Dentist wants teeth for his collection. You need to craft an Ump-o-Lantern using Denis's supplies, and take it to Stu. <br/>
         <i class="fa-solid fa-1" style="color: #9a7997;"></i> You will need Teeth from the Maul-a-Skaul event, which you can play in the Guild Hall (go north from Denis). (See the Live Ops page for more info!)<br/>
         <i class="fa-solid fa-2" style="color: #9a7997;"></i> When you have enough teeth to buy all 4 items, purchase them.<br/>
         <i class="fa-solid fa-3" style="color: #9a7997;"></i> Head to Ouiji and craft your Ump-o-Lantern at his station<br/>
         <i class="fa-solid fa-4" style="color: #9a7997;"></i> After you have crafted one Ump-o-Lantern, go talk to Stu. He will give you an Ump-o-Thumper to smash open that Lantern<br/>
         <i class="fa-solid fa-5" style="color: #9a7997;"></i> Click on the Lantern from your inventory and place it on the table, then select the Thumper and smash it twice. You will get a costume! (I got the vamp!) <br/>
        `,
      items: ["None"],
      reward: "Free Ump-o-Thumper to open your first two Lanterns",
      otherinfo: "Live October 23rd 2024 - November 1st 2024",
      image: ["https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B2047E0C4-B37F-42CB-8C4F-29E3396C037F%7D.png"],
    },
    {
      id: 37,
      name: "Barney's Bat-ch Catch",
      status: "expired",
      npc: "Barney",
      location: "Guild Hall Exterior - Barney will be located ouside",
      description: `Until Halloween, 3 New Bats will be available each day until 1pm PST ( 8PM UTC ). Collect all 27 bats for a secret surprise!<br/>For specific locations, check out the <a href="/game-wiki/events/summary" rel="noreferrer" target="_blank">Halloween Events page</a>. `,
      items: ["27 Bats"],
      reward: "Unknown atm",
      otherinfo: "Live October 23rd 2024 - November 1st 2024",
      image: [],
    },
    {
      id: 36,
      name: "Reputable Banker",
      status: "available",
      npc: "Margaret",
      location: "Bank",
      description: `Purchasing Coins using $PIXEL activates and completes the quest! Any amount you purchase will work.<br/>
        Can only be completed once.`,
      items: ["None"],
      reward: "100 Rep for first purchase",
      otherinfo: "The quest isn't really a quest? I think ( ﾉ ﾟｰﾟ)ﾉ | Live Oct 15 2024",
      image: [],
    },
    {
      id: 35,
      name: "Winery? More Like Sublimery",
      status: "expired",
      npc: "Winona",
      location: "Right of The Drunken Goose - Bottom Left of the Fountain",
      description: `<img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B181ED1FF-05F3-4457-9503-E5F5B08FAF12%7D.png" alt="Winery Quest" width="450" height="450"/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Click on Winona to start up the Winery Quest! She's going to request 36 Popberries, 10 Cooking Mix, 3 Honesy, 1 Silk Slug Slime and a Glass Bottle to get started. <br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need to get these from various places: 
        <br/> ➡️ Popberries are From Farming 
        <br/> ➡️ Cooking Mix from the Shop (The Bucks Galore) 
        <br/> ➡️ Honey from an Apiary
        <br/> ➡️ Silk Slug Slime from Slug Hutches (Level 2 Animal Care needed)
        <br/> ➡️ 1 Glass Bottle (needed from Stoneshaping Level 2)
        <br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you've got the ingredients, click on Winona again. She will instruct you to craft a Bottle of Popberry Wine. This will take 1 Minute <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> Talk to Winona again after you've acquired the wine (Conveniently you can also give her an already crafted one if you don't want to wait 1 Minute (●'◡'●) )<br/>`,
      items: ["36 Popberries", "10 Cooking Mix", "3 Honey", "1 Silk Slug Slime", "1 Glass Bottle"],
      reward: "190 Coins",
      otherinfo: "Introduction to Winery Quest | Live Oct 15 2024",
      image: [],
    },
    {
      id: 34,
      name: "The Apparel Heir Apparent",
      status: "available",
      npc: "Tex",
      location: "South of the Bank - Bottom Right of the Fountain",
      description: `<img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BC9A6D322-792D-4390-85B7-AD2D7C0B874D%7D.png" alt="Textiler Quest" width="450" height="450"/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Click on Tex to start up the Textiler Quest! He's going to request 4 Silk Fiber and 4 Silk Slimes to get started. <br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need to get these from a Slug Hutch - There's a public one north east of Terra Villa. You get a Slug from the Pet Store and place it on a hutch, then collect every Hour! Or you can buy the ingredients.<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you've got the ingredients, click on Tex again. He will instruct you to craft a Silk Rope. This will take 1 Minute in the Textile Station in front of him <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> Talk to Tex again after you've acquired the rope (Conveniently you can also give him an already crafted one if you don't want to wait 1 Minute (●'◡'●) )<br/>`,
      items: ["4 Silk Fiber (Level 0 Animal Care) & 4 Silk Slug Slime (Level 2 Animal Care)"],
      reward: "60 Coins",
      otherinfo: "Introduction to Textiler Quest | Live Oct 15 2024",
      image: [],
    },
    {
      id: 33,
      name: "Off To The Daily Grind",
      status: "available",
      npc: "Gill",
      location: "Bottom left of the Theater - Top left from the fountain",
      description: `<img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B6FD7415C-6803-4719-A7E5-D29E4A65E1AC%7D.png" alt="Windmill Quest" width="450" height="450"/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Click on Gill to start up the Windmill Quest! He's going to request 2 Grainbows to get started. <br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need to get these by planting them - you need to be level 5, and you can get the seeds from the store.<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you've got the Grainbow, talk to Gill again. He'll ask you to make one Grainbow Flour in the Windmill. Open up the Windmill Behind Gill and select Grainbow Flour from the Recipes.<br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> In 3 Minutes, you should get your Grainbow Flour from the Windmill<br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i> Talk to Gill again after (Conveniently you can also give him an already crafted one if you don't want to wait 3 Minutes (●'◡'●) )<br/>`,
      items: ["1 Grainbow (Level 2 Farming)"],
      reward: "20 Coins",
      otherinfo: "Introduction to Windmill Quest | Live Oct 15 2024",
      image: [],
    },
    {
      id: 32,
      name: "A Rocky Start",
      status: "available",
      npc: "Sandy",
      location: "Left of Pixels HQ - Top left of Fountain",
      description: `<img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7B4D73BC31-8D62-40E9-8E6E-39B0458E6128%7D.png" alt="Stoneshaping Quest" width="450" height="450"/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Click on Sandy to start up the Stoneshaping Quest! She's going to request 2 Clayum Matrix to get started. <br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need to get these from a Mine - you can get some by using the Mine on your Speck!<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you've got the Clayum Matrix, click on Sandy again. She will instruct you to craft a Clayum Powder. <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> Use the log on the Stoneshaper behind Sandy (by clicking the log and clicking on the stoneshaper)<br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i> Click on the Stoneshaper and select Clayum Powder from the Recipe Book. Click Create. This will take 1 Minute to Craft. <br/>
        <i class="fa-solid fa-6" style="color: #9a7997;"></i> Talk to Sandy again after you've acquired the powder (Conveniently you can also give her an already crafted one if you don't want to wait (●'◡'●) )<br/>
        `,
      items: ["2 Clayum Matrix, 1 Log"],
      reward: "20 Coins",
      otherinfo: "Introduction to Stoneshaping Quest | Live Oct 15 2024",
      image: [],
    },
    {
      id: 31,
      name: "That's so METAL!",
      status: "available",
      npc: "Smith",
      location: "Top right of Fountain - Right of Pixels HQ",
      description: `<img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BF82E8407-75A8-403D-9BC0-7415999803D7%7D.png" alt="Metalworking Quest" width="450" height="450"/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Click on Smith to start up the Metalworking Quest! He's going to request 3 Copperite Ore to get started. <br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need to get these from a Mine - you can get some by using the Mine on your Speck!<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you've got the Copperite Ore, click on Smith again. He will instruct you to craft a Copperite Bar. <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> Click on the Metalworking Bench to the left of Smith, and select Copperite Bar and Create. In 1.5 Minutes, you should get your Copperite Bar from the Bench<br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i> Talk to Smith again after you've acquired the bar (Conveniently you can also give him an already crafted one if you don't want to wait 1.5 Minutes (●'◡'●) )<br/>
        `,
      items: ["3 Copperite Ore"],
      reward: "20 Coins",
      otherinfo: "Introduction to Metalworking Quest | Live Oct 15 2024",
      image: [],
    },
    {
      id: 30,
      name: "Shoulda, Wood-a, Coulda!",
      status: "available",
      npc: "Jack",
      location: "Left of Fountain",
      description: `<img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BC40C6D3F-9E16-4FF6-BDB5-016A1E092B3F%7D.png" alt="Woodworking Quest" width="450" height="450"/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Click on Jack to start up the Woodworking Quest! He's going to request 3 Logs to get started. <br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> You will need to get these from a Tree marked with spraypaint - You might even have some trees on your Speck!<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> Once you've got the Logs, click on Jack again. He will instruct you to craft a Plank. <br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i> Click on the Woodworking Bench to the right of Jack, and select Whitelwood Plank and Create. In 1.5 Minutes, you should get your Plank from the Bench<br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i> Talk to Jack again after you've acquired the plank (Conveniently you can also give him an already crafted one if you don't want to wait 1.5 Minutes (●'◡'●) )<br/>`,
      items: ["3 Logs"],
      reward: "20 Coins",
      otherinfo: "Introduction to Woodworking | Live Oct 15 2024",
      image: [],
    },
    {
      id: 29,
      name: "Welcome to the Buck's Galore, Quality Goods from Ceiling to Floor!",
      status: "available",
      npc: "Buck",
      location: "Inside Buck's Galore (Right of Fountain)",
      description: `<img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/%7BB39C2FFF-2B0E-4967-9F5E-359F78FB98EA%7D.png" alt="Bucks Quest" width="450" height="450"/><br/>
        <i class="fa-solid fa-1" style="color: #9a7997;"></i> Click on Buck to trigger the quest. He will give you a 10 Coin store credit. <br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i> Click on the counter to purchase a Mover using the 10 Coins!<br/>
        <i class="fa-solid fa-3" style="color: #9a7997;"></i> After you purchase the Mover, you will complete the quest. He says you can talk to Jack next! <br/>
        `,
      items: ["None"],
      reward: "None",
      otherinfo: "Introduction to the Shop | Live Oct 15 2024",
      image: [],
    },
    {
      id: 28,
      name: "Barney's Bazaarn Position Decision",
      status: "expired",
      npc: "Barney, Tina",
      location: "Barney's Bazaarn",
      description: `<div class="leading-relaxed"><i class="fa-solid fa-1" style="color: #9a7997;"></i>. Head to the Bazaarn in the Northern parts of Terra Villa. Barney's in a predicament! He has a lot of jobs that need to be done.<br/>
        <i class="fa-solid fa-2" style="color: #9a7997;"></i>. Talk to Barney to get the quest and then pick a contract. You can only pick one! So choose wisely.<br/>
        <i class="fa-solid fa-message" style="color: #9a7997;"></i> For context: each contract determines what your future working for Barney will look like (your rewards and multipliers)<br/><br/>
        <table class="table1 bg-retrobg"><thead><tr><th></th><th>Picker Packer</th><th>Warehouse Warrior</th><th>Bazaarn Boss</th></tr></thead>
        <tbody>
        <tr><td>Gacha Tickets</td><td>5</td><td>10</td><td>20</td></tr>
        <tr><td>Outfit</td><td><img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/JumpsuitIcon03-export.png" alt="Jumpsuit1" width="20" height="20"/></td><td><img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/JumpsuitIcon02-export.png" alt="Jumpsuit2" width="20" height="20"/></td><td><img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/JumpsuitIcon03_(1)-export.png" alt="Jumpsuit3" width="20" height="20"/></td></tr>
        <tr><td>Reputation<br/>Points</td><td colSpan="3" class="text-center">Unknown (same rep will be for all)</td></tr>
        <tr><td title="Multiplier is for the event">$PIXEL<br/>Multiplier</td><td>Small</td><td>Bigger</td><td>Biggest</td></tr>
        <tr><td>Cost</td><td>20 $PIXEL</td><td>30 $PIXEL</td><td>40 $PIXEL</td></tr>
        </tbody></table>
        <br/><i class="fa-solid fa-3" style="color: #9a7997;"></i>. After you have decided on a contract, click on Barney again and he will allow you to pick from the three contracts. Remember you can only use ONE. If you purchase multiple or buy the wrong one, you're SOL. ＞﹏＜<br/>
        <i class="fa-solid fa-4" style="color: #9a7997;"></i>. Head to Tina who is up the stairs inside the Bazaarn and on the left. She will take the contract from you and give you your Bazaarn Tickets.<br/>
        <i class="fa-solid fa-5" style="color: #9a7997;"></i>. You are now an official worker for Barney's Bazaarn! Check out our <a href="/game-wiki/events" class="text-retropink hover:text-white">events page</a> to get more information when the Bazaarn is live!~</div><br/>
        Use your new Green Gacha Clams to roll the Gacha Machine and try your luck.<br/>
        This quest is completely optional and you can still participate in the event even if you don't purchase a contract!
        <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Event+Screenshots/image_2024-09-10_225724782.png" alt="gachamachine" width="150" height="150"/>`,
      items: ["None"],
      reward: "Depends on the Contract you pick (see table above)",
      otherinfo: "September 10th 2024 - September 11th 2024",
      image: [],
    },
    {
      id: 27,
      name: "Okx Fokx Box",
      status: "expired",
      npc: "Mr. Okayecks",
      location: "Basement of the Bank",
      description: `Head to the basement of the bank and chat with Mr. Okayecks. He will give you 5 Fokx Bokx to cath 5 Fokxes. Head Back to Terra Villa and start hunting for Fokxes around. When you get close, try to use the Fokx Box to catch it! There is RNG to catching them so don't worry if they run away. Just keep trying until you catch 5. When you have 5 Fokx in a Bokx, go back to the Bank's Basement and place the boxes on the pedestals in front of Mr. Okayecks.`,
      items: ["None"],
      reward: "1 OKX Snapback Wearable and a raffle drawing for a Fokx Pet (1/5)",
      otherinfo: "August 14 2024 - August 19 2024",
      image: [],
    },
    {
      id: 26,
      name: "Happy Birthday, Luke!",
      status: "expired",
      npc: "Boss, Luke",
      location: "The Buck's Galore",
      description: `Go to Boss in the Buck's Galore to start the quest and get the Funky Bday Cake Recipe. Purchase the Recipe from the Shop next to Boss, and then click it from your inventory and use it on yourself. 
        <br/>Now you know how to make a birthday cake. Go find a stove. and the Cake Recipe will be a Tier 1 Recipe. <br/>
        The recipe requires 12 Clay Matrix, 6 Grainbow Flour, 6 Honey, 3 Eggs, 1 Syrup and 1 Cooking Mix. For crafting, it takes 1 minute, it gives 1 Exp, and it costs 1 Energy to Craft.<br/>
        After it's completed, take the cake back to Boss. He will then give you a Surfboard to get to Luke. Go to the right hand side of the Guild Caste (where it says Surf Station, Place Board), place the board, and head to Luke's Private Island<br/>
        There will be a small green tent. Select the cake, and click on the tent. He will then take the cake, thank you for it and give you Luke's Robe`,
      items: ["10 $PIXEL"],
      reward: "Luke Express Surfboard, Luke's Robe",
      otherinfo: "August 9 2024 - August 10 2024",
      image: [],
    },
    {
      id: 25,
      name: "Page Perry’s PIXELS Pavilion Parley",
      status: "expired",
      npc: "Page Perry",
      location: "Pixel HQ",
      description: `This was a quest where you loaded into a maze to find an X! The Maze could be in the shape of any of the letters from the word PIXELS.`,
      items: [],
      reward: "400 Reputation & Pixels Maze Trophy",
      otherinfo: "July 23 2024",
      image: [],
    },
    {
      id: 24,
      name: "Guide to Guilds: 1, 2 & 3",
      status: "expired",
      npc: "Player_W3, Gabby & Luke",
      location: "Guild HQ",
      description: `A quest for the hunt of a Power Pixel in the dungeons! This quest was a scavenger hunt of various items.`,
      items: [],
      reward: "200 Reputation, Power Pixel, Fingerprint, and a Magnifying Glass",
      otherinfo: "July 17 2024",
      image: [],
    },
    {
      id: 23,
      name: "Shorelimade for Shorelime Shades",
      status: "expired",
      npc: "Heidi",
      location: "Beach",
      description: `Craft 6 Shorelimeade  for Heidi.`,
      items: [],
      reward: "350 Reputation, Shorelime Shades",
      otherinfo: "June 20 2024",
      image: [],
    },
    {
      id: 22,
      name: "Jihoz's Shake Break",
      status: "expired",
      npc: "Jihoz",
      location: "Carnival [CH1TV] and/or Top Right Terra Villa [CH2TV]",
      description: `Craft a Cotton Candy Milkshake for Jihoz.`,
      items: [],
      reward: "250 Reputation, 1 Fishing Net",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 21,
      name: "Karen's Latte of Gratitude",
      status: "expired",
      npc: "Karen",
      location: "Karen's House [CH1TV]",
      description: `Craft a Grumpkin Spiced Latte for Karen.`,
      items: [],
      reward: "Recipe for 12 Grumpkin Spiced Lattes",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 20,
      name: "Roamin' for Ronin!",
      status: "expired",
      npc: "Ron",
      location: "Near the Fountain [CH1TV]",
      description: `Craft 10 Ronin Chains using Ronin Blocks found around Terra Villa.`,
      items: [],
      reward: "100$BERRY per Ronin Chain",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 19,
      name: "Wine Not [Popberry to Muckchuck]!",
      status: "expired",
      npc: "Goose",
      location: "Drunken Goose",
      description: `Craft 24 Bottles of Each Wine:<br/>Quest 1: Popberry<br/>Quest 2: Butterbrew<br/>Quest 3: Grainshine<br>Quest 4: Grumpkin Wine<br>Quest 5: Scarrot Wine<br>Quest 6: Watermint Whiskey<br>Quest 7:Astracactus Tequila<br>Quest 8:Hotato Hotka<br>Quest 9:Muckchuck Mead`,
      items: [],
      reward: "2 Bottles + Coin Cost of 24 Bottles<br>Quest 1 had 50 Reputation<br>Quest 2 Had 250 Reputation",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 18,
      name: "Fuy Gieri's Barbequest 1-4!",
      status: "expired",
      npc: "Fuy Gieri",
      location: "Drunken Goose [CH1TV]",
      description: `Craft BBQ Sauces, and every meal from each grill [Land, Water and Space].`,
      items: [],
      reward: "75 Reputation each for Quests 2, 3 and 4",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 17,
      name: "The Buck's Galore!",
      status: "expired",
      npc: "Hazel",
      location: "The Buck's Galore [CH1TV]",
      description: `Hazel guides you through use of the shop and explains how to get to other NPCs.`,
      items: [],
      reward: "None",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 16,
      name: "Axeing for Help",
      status: "expired",
      npc: "Lumber Jill",
      location: "South of Terra Villa [CH1TV]",
      description: `Lumber Jill teaches you how to cut wood, and asks you to cut some wood for her..`,
      items: [],
      reward: "1 Axe, 1 Energy Drink and 100 Forestry Exp",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 15,
      name: "Sticks and Planks",
      status: "expired",
      npc: "Stan Stolan and Old Man Gurney",
      location: "South East Terra Villa [CH1TV]",
      description: `Stan Stolar asks you to craft 8 sticks, and then 1 stool for Old Man Gurney..`,
      items: [],
      reward: "20 Coins, 100 Woodworking Exp",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 14,
      name: "Cooking with Karen",
      status: "expired",
      npc: "Karen",
      location: "Karen's House [CH1TV]",
      description: `Karen asks you to cook a Popberry Pie.`,
      items: [],
      reward: "2 Eggs, 100 Cooking Exp",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 13,
      name: "Axeing for Help",
      status: "expired",
      npc: "Lumber Jill",
      location: "South of Terra Villa [CH1TV]",
      description: `Lumber Jill teaches you how to cut wood, and asks you to cut some wood for her..`,
      items: [],
      reward: "1 Axe, 1 Energy Drink and 100 Forestry Exp",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 12,
      name: "Honor Bound & Even More Boxes",
      status: "expired",
      npc: "Honor",
      location: "Post Office",
      description: `Honor teaches you how to decorate a speck after you acquire one.`,
      items: [],
      reward: "1 Lithe Bush, 1 Random Rock 1, 1 Symmetrical Bush, 1 Simple Bush, 1 Imposing Bush, 1 Simple Bush (Flowering)",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 11,
      name: "Sunshine & Grainbows / Flour Powder",
      status: "expired",
      npc: "Fitz",
      location: "North West of Terra Villa",
      description: `Fitz asks you to grow 4 grainbow seeds, and then asks you to turn them into flour.`,
      items: [],
      reward: "4 Grainbow Seeds, 100 Granger Exp",
      otherinfo: "Ended with Chapter 2's release - June 17th 2024",
      image: [],
    },
    {
      id: 10,
      name: "$MOCA Public Sale Code Contest",
      status: "expired",
      npc: "Mo",
      location: "Mocaverse Club House",
      description: `Craft 3 Moca Stars for Mo.`,
      items: [],
      reward: "Chance to Win Mocaverse Whitelist.",
      otherinfo: "March 30 2024 - April 3 2024",
      image: [],
    },
    {
      id: 9,
      name: "Rescue the Seasonal Sip",
      status: "expired",
      npc: "Staff",
      location: "Carnival left of the Orange Grumpkin Machine[CH1TV]",
      description: `Harvest 12 Grumpkins for the Staff Member.`,
      items: [],
      reward: "100 Game Tickets",
      otherinfo: "October 1 - 31 2023 for Carnival",
      image: [],
    },
    {
      id: 8,
      name: "999 Shorelime Time!",
      status: "expired",
      npc: "Buck",
      location: "Terra Villa Beach",
      description: `Plant 999 Shorelimes within 24 hours!`,
      items: [],
      reward: "Shorelime Tiki",
      otherinfo: "July 26th 2023",
      image: [],
    },
    {
      id: 7,
      name: "Tastemakerz Scene Shakers!",
      status: "expired",
      npc: "Master Wabi-san, Coach, E",
      location: "West Terra Villa, Sauna and North West Terra Villa",
      description: `Deliver messages around to the different NPCs`,
      items: [],
      reward: "1 Tastemaster Burger Combo",
      otherinfo: "Was a teaser event for Tastemakerz - Lasted from April 7 2023 - May 14 2023",
      image: [],
    },
    {
      id: 6,
      name: "Steven & Todd's Bad Hare Day",
      status: "expired",
      npc: "Steven & Todd",
      location: "East and West Terra Villa",
      description: `Search for Easter Eggs all over Terra Villa and return them to Steven or Todd for a reward. Odd Eggs to Todd, Even eggs to Steven.`,
      items: [],
      reward: "$BERRY per egg",
      otherinfo: "April 4th 2023 - April 18th 2023",
      image: [],
    },
    {
      id: 5,
      name: "Luck of the Four-Leaf Clover",
      status: "expired",
      npc: "Margaret",
      location: "Terra Villa (old ch1)",
      description: `Bring 1 4-leaf clover to Margaret for a prize.`,
      items: [],
      reward: "Leprechaun Sculpture, and the ability to find pots of gold around on different Farm Maps which could be sold for 317 $BERRY each.",
      otherinfo: "Quest Lasted March 7 2023 - March 23 2023",
      image: [],
    },
    {
      id: 4,
      name: "Wine Not? Heartbeet Delivery Service",
      status: "expired",
      npc: "Goose",
      location: "The Drunken Goose",
      description: `Help Goose craft 24 Heartbeet Wines at Winona's newly-opened Winery.`,
      items: [],
      reward: "3,500 $BERRY, and an invite to the energy parties which had 240 Energy and 600 $BERRY in total",
      otherinfo: "Feb 7 2023 - Feb 21 2023",
      image: [],
    },
    {
      id: 3,
      name: "A Coinbase Christmas",
      status: "expired",
      npc: "Marcus the Mycelimancer",
      location: "Old South East Terra Villa Map",
      description: `Locate the NPC, receive a Coinbase gift box and open it up using one of the obelisks.`,
      items: [],
      reward:
        "Possible Rewards: Apiary (50), Elephant Topiary (450), Gnome1 (500), Gnome2 (500), Pond (500), Bush (1500), Iron Bar (1500). There were a total of 5000 Coinbase Boxes",
      otherinfo: "Dec 19 2022 - Dec 21 2022",
      image: [],
    },
    {
      id: 2,
      name: "Merry Merry Christmas",
      status: "expired",
      npc: "Santa Barney",
      location: "Fountain",
      description: `Santa Barney dropped all of his candy canes all over Terra Villa. He needs you to help him find them. Needed to find 19 Blue, 19 Red and 19 Green Candy Canes.`,
      items: [],
      reward: "2 Turkey Eggs, 1 Concrete Snowman 2022",
      otherinfo: "Dec 19 2022 - Dec 21 2022",
      image: [],
    },
    {
      id: 1,
      name: "Tanksgiving",
      status: "expired",
      npc: "Tom Goeble, Goose",
      location: "Thanksgiving Map",
      description: `Tom Goeble owed Goose, and he asks if you can repay Goose on your behalf.`,
      items: [],
      reward: "1 Turkey Egg, 1 Ornamental Fish Tank 2022",
      otherinfo: "Nov 23 2022 - Dec 1 2022",
      image: [],
    },
    {
      id: 0,
      name: "Basics with Barney",
      status: "available",
      npc: "Barney, Margaret",
      location: `Barney's Farm & Beginner Speck`,
      description: `
          I: First, Barney welcomes you to the game and asks you to walk towards him. Directional Arrows show on the screen to guide you. He asks you to speak to him so click on him!
          II: You can choose to customize your character or click Later, whichever your preference is. Once completed, Barney will ask you to plant a <i>Popberry Seed</i>. At each step, he is going to give you the essential tools.<br/>
          III: First put the popberry seed into the ground.<br/> then he will give you a <i>Rusty Watering Can</i> to water the seed.<br/>
          IV: When it has been watered, Barney will provide you with a <i>Basic Shears</i>. After 10 seconds, you can clip that Popberry out of the ground.<br/>
          V: Next, he'll give you 6 more popberry seeds! Follow Steps II - IV again for all 6 of them, or you can skip planting them.<br/>
          VI: Barney will give you a <i>Basic Axe</i> to chop some trees. Take the Axe from your bag, pick a tree and start whacking it.<br/>
          VII: When you've finished cutting down a tree, talk to Barney again. He'll commend you and send you off to the house.<br/>
          VIII: Once in the house, talk to Margaret. Add one of the logs you cut down to the stove next to Margaret.<br/>
          IX: The stove will be lit, and Margaret will ask you to create one <i>Popberry Jam</i>. After 10 secondws, claim the jam and talk to Margaret again.<br/>
          X: Head outside and talk to Barney again. He'll send you to your own Speck. Barney will give you 24 Popberry seeds, and you'll get a Beginner Infinifunnel Task for 1 Popberry Jam!<br/>
          XI: Deliver the Popberry Jam to the Infinifunnel inside the house.<br/>
          XII: Barney will come back to give you a <i>Basic Pick</i>. Head outside of your house and use the Pick on the grey <i>Mine</i> outside until you get something from it<br/>
          XIII: You're now free to go wherever you want. Explore Terra Villa, talk to NPCs, visit other lands and players. Go have fun!<br/>
        `,
      items: ["None needed, everything is provided"],
      reward: `30 Coins`,
      otherinfo: `See more about your Speck <a href='/game-wiki/land-specks'>here</a>`,
      image: [
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/beginnerquest1.png",
        "https://pixelore.s3.eu-central-003.backblazeb2.com/Quest+Data/beginnerquest2.png",
      ],
    },
  ],
};

export default questsData;